// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import getIltCourseDataActions from './getIltCourseDataActions';
import getIltCourseContentsDataActions from './getIltCourseContentsDataActions';
import updateIltCourseProgressActions from './updateIltCourseProgressActions';

export default {
  getIltCourseDataActions,
  getIltCourseContentsDataActions,
  updateIltCourseProgressActions
}
